module.exports = __webpack_public_path__ + "img/Novicell-logo-2018-white-cmyk.a524198e.png";